module.exports = __webpack_public_path__ + "img/del_test.16a0d9dc.gif";